<template>
  <div>
    <SModalPortalTo v-if="showCourseMemberRedirectLink && entry.meta" is-modal-header-sub-title>
      <div class="d-flex justify-content-center">
        <b-button
          class="p-0 with-icon auto-height font-weight-bolder"
          variant="link"
          data-cy="open-course-member-list-header"
          :aria-label="memberLabel"
          @click="openCourseMemberList"
        >
          <span class="nano">{{ entry.meta.label }}</span>
          <sdui-icon class="icon-arrow-o nano mr-n1" />
        </b-button>
      </div>
    </SModalPortalTo>

    <sdui-waterfall-search
      v-model="users"
      :url="url"
      :model="User"
      :class="{ 'mb-5': isWaterfallSearchLoading }"
      class="mt-3"
      :no-gutters="true"
      data-cy="notice-users-waterfall"
      no-padding
      :search-input-label-sr-only-text="$t('classbook.notices.create.choose_students_modal_title')"
      @loading="(isLoading) => (isWaterfallSearchLoading = isLoading)"
    >
      <template #content>
        <SList class="pt-2">
          <sdui-user-list-item
            v-for="user in users"
            :key="user.id"
            :user="user"
            class="right-action-event-none"
            data-cy="notice-user"
            :aria-pressed="!!selectedUsers.find((s) => s.id === user.id)"
            @click="toggleUser(user)"
          >
            <template #action>
              <SCheckbox
                :model-value="selectedUsers.some((s) => s.id === user.id)"
                checkbox-type="round"
                name="select-user"
                :label-text="user.meta.displayname"
                force-styled-checkbox
              ></SCheckbox>
            </template>
          </sdui-user-list-item>
        </SList>
      </template>
    </sdui-waterfall-search>

    <div v-if="showCourseMemberRedirectLink" class="container">
      <div class="nano text-muted m-0 text-center mt-2">
        {{ $t('classbook.notices.create.add_user_to_course_hint', { courseGrade: entry.meta.label }) }}
      </div>
      <b-button
        variant="link"
        class="d-flex align-items-center justify-content-center w-100 mt-2"
        data-cy="open-course-member-list-bottom"
        :aria-label="memberLabel"
        @click="openCourseMemberList"
      >
        <p class="font-weight-bold mb-0">
          {{ $t('classbook.course_member_management.title_with_grade_course', { courseGrade: entry.meta.label }) }}
        </p>
        <sdui-icon class="icon-arrow-o icon-24 ml-1" />
      </b-button>
    </div>

    <SModalPortalTo>
      <b-button variant="primary"
                size="lg"
                block
                data-cy="select-user-modal-submit-btn"
                @click="$emit('saveUsers')"
      >
        {{ $t('global.save') }}
      </b-button>
    </SModalPortalTo>
  </div>
</template>

<script>
import SduiWaterfallSearch from 'src/components/miscellaneous/ui/common/SduiWaterfallSearch.vue'
import { User } from 'src/store/models/index.js'
import SduiUserListItem from 'src/components/user/SduiUserListItem.vue'
import SModalPortalTo from 'src/components/base/SModal/SModalPortalTo.vue'
import Classbooks from 'src/api/classbooks.js'

import SCheckbox from 'src/components/base/SCheckbox.vue'

export default {
  // TODO VUE3: Remove compatConfig when @vue/compat is removed
  compatConfig: {
    COMPONENT_V_MODEL: false,
  },

  name: 'ClassbookNoticeUsers',
  components: { SduiWaterfallSearch, SduiUserListItem, SModalPortalTo, SCheckbox },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },

    entry: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    users: null,
    User: User,
    selected: [],
    selectedUsers: [],
    isWaterfallSearchLoading: false,
  }),

  computed: {
    url() {
      return `${Classbooks.noticesByEntryIdUrl(this.entry.classbook_id, this.entry.id)}&`
    },

    showCourseMemberRedirectLink() {
      return this.entry.course_id
    },

    memberLabel() {
      const grades =
        this.entry.grades.length > 1
          ? this.$t('timetable.components.choose_entity.entities.grade.plural')
          : this.$t('timetable.components.choose_entity.entities.grade.singular')
      return `${this.$t('classbook.course_member_management.title_with_grade_course_screenreader_hint')} ${grades} ${this.entry.meta.label}`
    },
  },

  emits: ['saveUsers', 'update:modelValue'],

  methods: {
    toggleUser(user) {
      this.selectedUsers = this.selectedUsers.find((s) => s.id === user.id)
        ? this.selectedUsers.filter((s) => s.id !== user.id)
        : [...this.selectedUsers, user]
      this.$emit('update:modelValue', this.selectedUsers)
    },

    async openCourseMemberList() {
      // in addition to the notice object, we also have to save the state of the currently selected users so we
      // can restore it if the user comes back from DC
      await this.$store.commit('timetable/SET_NOTICE_CREATION_USERS', this.selectedUsers)
      // open DC course membership
      this.$router.push({
        name: 'classbook-entity-details-users',
        query: { entity: 'courses' },
        params: { id: this.entry.course_id, classbook: this.entry.classbook_id, entity: 'courses' },
      })
    },
  },

  watch: {
    modelValue: {
      handler: function (selectedUsers) {
        if (!selectedUsers?.length) return
        this.selectedUsers = [...selectedUsers]
      },

      immediate: true,
    },
  },
}
</script>
